var typingTimer;
var typingTimerMax = 800;
var Ajax = { ajaxurl: "/wp-admin/admin-ajax.php" };
var siteSearchActive = false;

(function($) {
  // init hooks
  searchHooks();
  
  function searchHooks() {
    // activating search via header
    $('.header__searchTrigger').on('click',function(){
      siteSearch('');
    });

    // searching on Search Hero and Search Landing
    $(document).on('submit', '.search-banner__search, .main-search__head__input', function(e){
      e.preventDefault();
      siteSearch($(this).find('input').val());
    });

    $(document).on('keyup', '.search-banner__search input, .main-search__head__input input', function(){
      var ref = $(this).closest('.search-banner, .main-search__head__input');
      clearTimeout(typingTimer);
      typingTimer = setTimeout(function(){ doneTyping(ref) },typingTimerMax);
    });
  }

  function doneTyping(banner) {
    if (!siteSearchActive) {
      var searchVal = banner.find('input[type="text"]').val().trim();
      console.log('running dropdown search for: ',searchVal);
      if (searchVal.length>0) {
        bannerSearch(searchVal, banner);
        banner.find('.search-banner__results, .main-search__head__results').slideDown();      
      } else {
        banner.find('.search-banner__results, .main-search__head__results').last().slideUp();
      }
    }
  }

  function bannerSearch(term,banner) {
    banner.find('.search-banner__results, .main-search__head__results').html('<img src="/wp-content/themes/hostedVillas/public/img/30.svg">');
    // post the search term to the custom search_dropdown ajax fxn      
      $.post( Ajax.ajaxurl, {
          searchTerm: term,
          action: 'banner_search'
      }, function(res) {
          // Return the results from the function
          banner.find('.search-banner__results, .main-search__head__results').html(res); 
          if (banner.find('.search-banner__results, .main-search__head__results').outerHeight() > $(window).outerHeight()-53) {
            banner.find('.search-banner__results, .main-search__head__results').css('height',$(window).outerHeight()-53).css('overflow-y','scroll');
          }
          // activate HOOKS
          lazyLoadInstance.update();
          // using brand switcher on main search
      $('.main-search__switcher__item').on('click',function(){
        switchBrand($(this));
      });
      });
  }

  function siteSearch(term) {
    clearTimeout(typingTimer);
    siteSearchActive = true;
    $('.header__searchTrigger img, .main-search__head__input img').attr('src','/wp-content/themes/hostedVillas/public/img/25.gif');
    var ajaxOptions = {
      searchTerm: term,
      action: 'ajax_search_panel'
    };
    console.log(ajaxOptions);
    $.post( Ajax.ajaxurl, ajaxOptions, function(data) {
      $('.header__searchTrigger img, .main-search__head__input img').attr('src','/wp-content/themes/hostedVillas/public/img/search-icon.svg');
      if (!$('.main-search').length) {
        $('body').append(data);           
        $('.main-search').slideDown(function(){
          bodyScrollLock.disableBodyScroll($('body')[0]);
          $('.main-search__head__input input').focus();
        });
      } else {
        $('.main-search').replaceWith(data);
        $('.main-search').show();
        bodyScrollLock.disableBodyScroll($('body')[0]);
      }
      siteSearchActive = false;
      postLoadHooks();      
    });
  }

  function postLoadHooks() {
    lazyLoadInstance.update();
    // show card text immediately, no animation
    $('.main-search .hv-card__main__text').css('opacity','1');
    // hook for main search close
    $('.main-search__close').on('click',function(){
      bodyScrollLock.clearAllBodyScrollLocks();
      $('.main-search').last().slideUp('slow',function(){
        $(this).remove();       
      });
    });
    //share modal
    $('.hv-post__share').on('click',function(){
      $('.share-modal').fadeIn();
    });
    $('.share-modal').on('click',function(e){
      if ($(e.target).hasClass('share-modal')) {
        $('.share-modal').fadeOut();
      }
    });
    $('.share-modal__close').on('click',function(){
      $('.share-modal').fadeOut();
    });
    $('.share-modal__box__options span').on('click',function(){
      $(this).append('<b style="font-weight:normal;margin-left:10px;">Copied!</b>');
      $(this).find('b').fadeOut(800,function(){$(this).remove();});
      var dummy = document.createElement('input'),
        text = window.location.href+'?s='+$('.main-search__head__input input').val();

      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
    });
    // equalizer reflow
    $('.main-search').foundation();
    $(window).trigger('blockHeight');
      Foundation.reInit('equalizer');
  }

})( jQuery );